import { render, staticRenderFns } from "./addTeamTeach.vue?vue&type=template&id=2f00fa4c&scoped=true"
import script from "./addTeamTeach.vue?vue&type=script&lang=js"
export * from "./addTeamTeach.vue?vue&type=script&lang=js"
import style0 from "./addTeamTeach.vue?vue&type=style&index=0&id=2f00fa4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f00fa4c",
  null
  
)

export default component.exports